import { BookOpen, Info } from "lucide-react";
import content from "../../data/content.json";

export interface LegalBlock {
  id: string;
  tag: string;
  title: string;
  text: string;
}

const DEFAULT_NOTICE = content.legal.multipropriedade.notice;

const BLOCKS: LegalBlock[] = content.legal.multipropriedade.blocks;

export function LegalInfo({ blocks = BLOCKS, notice = DEFAULT_NOTICE }: { blocks?: LegalBlock[]; notice?: string }) {
  return (
    <section data-testid="niche-legal-info">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500">Base legal</p>
        <h2 className="mt-3 max-w-2xl text-2xl font-semibold tracking-tight text-slate-100 sm:text-3xl">Entenda os fundamentos da notificação</h2>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {blocks.map((b) => (
            <article key={b.id} data-testid={`legal-block-${b.id}`} className="rounded-md border border-slate-800 bg-slate-900 p-6 sm:p-8">
              <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-emerald-500">
                <BookOpen aria-hidden="true" className="h-3.5 w-3.5" />{b.tag}
              </p>
              <h3 className="mt-4 text-lg font-semibold text-slate-100">{b.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{b.text}</p>
            </article>
          ))}
        </div>
        <p data-testid="niche-legal-notice" className="mt-8 flex max-w-3xl gap-2 text-xs leading-relaxed text-slate-500">
          <Info aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0" />
          {notice}
        </p>
      </div>
    </section>
  );
}
